<h4 class="vl-title vl-title--h4" [class.vl-title--has-border]="hasBorder">
    {{title}}
</h4>